import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { ExamesCargosModel } from "./exames-cargos.model";
import { ExamesCargosService } from './exames-cargos.service';
import { Funcoes } from "../../funcoes";
import { Global } from "../../global";

@Component({
  selector: 'app-exames-cargos-form',
  templateUrl: './exames-cargos-form.component.html'
})
export class ExamesCargosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  cargo: ExamesCargosModel = new ExamesCargosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private examesCargosService: ExamesCargosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome_pt: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]],
      nome_en: ['', [
        Validators.minLength(2),
        Validators.maxLength(100)
      ]],
      nome_es: ['', [
        Validators.minLength(2),
        Validators.maxLength(100)
      ]]
    });
  }

  ngOnInit() {
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    this.route.params.subscribe(params => {
      var id = params['id_cargo'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarCargo');
      } else {
        this.title = id ? this.func.traduzir('front.editarCargo') : this.func.traduzir('front.cadastrarNovoCargo');
      }

      if (this.pageIsAdd) {
        this.title = this.func.traduzir('front.cadastrarNovoCargo');
      }

      if (!id) {
        return;
      }

      this.examesCargosService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarCargo') + ': ' + json.Payload[0].nome_pt;
            } else {
              this.title = this.func.traduzir('front.visualizarCargo') + ': ' + json.Payload[0].nome_pt;
            }

            this.cargo = json.Payload[0];

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.nome_pt) {
      values.nome_pt = values.nome_pt.toUpperCase();
    }
    if (values.nome_en) {
      values.nome_en = values.nome_en.toUpperCase();
    }
    if (values.nome_es) {
      values.nome_es = values.nome_es.toUpperCase();
    }

    if (values.id) {
      result = this.examesCargosService.editar(values, values.id);
    } else {
      result = this.examesCargosService.adicionar(values);
    }

    result.subscribe(
      data => this.router.navigate(['/painel', 'exames', 'cargos']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/exames/cargos/exames-cargos-form.component.ts